<template>
  <div class="design-details edit" ref="designDetail">
    <div class="position-relative form-group details w-100">
      <input type="text" class="form-control" :value="data.name" disabled />
    </div>

    <div class="form-group w-100">
      <ul class="flags">
        <li v-for="(object, flag) in data.more.flags" :key="flag" class="radio-container">
          <input type="radio" name="design[flag]" :checked="data.flag == flag" :value="flag" @change="handleChangeFlag" />
          <span :class="`checkmark choose-flag ${flag}`"></span>
        </li>
      </ul>
    </div>

    <div v-if="['designer'].indexOf(data.more.user_role) == -1" class="form-group w-100">
      <label class="col-12 mb-2 p-0 text-capitalize">Designer</label>
      <Select source="user/search" type="auto" field="design.designer_read" placeholder="Designer" :value="data.designer_id" @changeValue="handleChangeDesigner"></Select>
    </div>

    <div class="attribute w-100">
      <template v-if="$_.isObjectLike(data.attributes)">
        <div v-for="(attribute, index) in data.attributes" :key="index" :class="`form-group ${index}`">
          <label class="col-12 mb-2 p-0 text-capitalize">{{ data.more.attributes[index] ? data.more.attributes[index].label : index }}: </label>
          <input type="text" class="form-control" :name="`design[attributes][${index}]`" :value="Object.values(attribute).join(', ')" @change="handleChangeAttribute($event, index)" />
        </div>
      </template>
      <div class="form-group">
        <label class="col-12 mb-0 p-0">Note</label>
        <ul class="notes">
          <li v-for="(note, index) in data.note" :key="index">
            <div class="input-group mt-2">
              <textarea class="form-control" name="design[note][]" :value="note" @change="handleChangeNote($event, index)"></textarea>
              <div class="input-group-append">
                <a @click.prevent="handleRemoveNote(index)" href="#remove" class="btn btn-light text-danger remove input-group-text">Remove</a>
              </div>
            </div>
          </li>
        </ul>
        <a @click.prevent="handleAddNote()" href="#add-more" class="btn btn-outline-primary mt-3 add-more">Add More</a>
      </div>
    </div>
    <div class="attribute text-right w-100">
      <a @click.prevent="$emit('cancelEditDetail')" href="#cancel" class="mb-2 ml-2 btn-transition btn btn-outline-light">Cancel</a>
      <a @click.prevent="submit" href="#save" class="mb-2 ml-2 btn btn-primary">Save</a>
    </div>
    <hr />
  </div>
</template>

<script>
import Event from '@/helper/event.js'
export default {
  mixins: [Event],
  data() {
    /* prettier-ignore */
    return {
      data: {
        name: '',
        flag: '',
        user_role: '',
        designer_id: null,
        note: [],
        more: {
          attributes: {},
          flags: {}
        }
      },
      submitStructure: [
        'designer_id',
        'attributes',
        'flag',
        'note'
      ],
      submited: false
    }
  },
  created() {
    this.setData(this.rawData)
  },
  computed: {
    storeId() {
      return this.config?.storeId
    },
    designId() {
      return this.config?.designId
    },
    submitUri() {
      return `design/update/${this.designId}`
    },
    rawData() {
      return this.store.getter('', {})
    },
    more() {
      return this.data?.more || {}
    },
    listStatus() {
      return this.more?.status || {}
    }
  },
  methods: {
    setData(value) {
      this.data = _.cloneDeep(value)
      if (!_.isArray(this.data.note)) {
        this.data.note = Object.values(this.data.note)
      }
      if (this.data.note.length == 0) {
        this.data.note.push('')
      }
    },
    handleChangeFlag(e) {
      this.data.flag = e.currentTarget.value
    },
    handleChangeDesigner(value) {
      this.data.designer_id = value
    },
    handleChangeAttribute(e, index) {
      this.data.attributes[index] = e.currentTarget.value.split(',').map((item) => {
        return item.trim()
      })
    },
    handleAddNote() {
      this.data.note.push('')
    },
    handleChangeNote(e, index) {
      this.data.note[index] = e.currentTarget.value
    },
    handleRemoveNote(index) {
      if (this.data.note.length > 1) {
        this.data.note.splice(index, 1)
      } else {
        this.data.note = ['']
      }
    },
    submit() {
      this.submitForm(
        this.data,
        {
          done: () => {
            if (this.data.designer_id) {
              this.data.status = 'confirm'
              this.data.more.can_action = 'confirm'
            }
            this.$emit('submitEditDetail', this.data)
          }
        },
        {
          $el: this.$refs.designDetail
        }
      )
    }
  },
  props: {
    config: Object
  },
  watch: {
    config(value) {
      this.data = value
    },
    rawData(value) {
      this.setData(value)
    }
  }
}
</script>
